const customerEndpoints = {
  accounting: () => '/reporting/customers/accounting'
}

export default customerEndpoints
